import React from 'react';
import { inject, observer } from 'mobx-react';
import H5TabFilter from './h5';
import PCTabFilter from './pc';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';

interface TabFilterProps {
    app?: AppStore;
    filterClick?: Function  // 导航点击事件
    boxWidth?: any   // 导航所占宽度
    zIndex?: number // 导航显示层级，默认为10 
    boxStylesData?: any // 导航最外层父级盒子自定义样式
    listStylesData?: any    // 导航列表样式自定义
    itemStylesData?: any// 每个导航自定义样式(比如间距(默认间距80rpx)，颜色等)
    filterList: any    // 筛选列表数据
    currentIndex?: number  // 当前点击的索引，默认为0，第一个被选中

}

@inject('app', 'site', 'user')
@observer
class TabFilter extends React.Component<TabFilterProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
        // console.log('组件组件');
    }

    render() {
        const { app, filterList, ...props } = this.props;
        const platform = app?.platform || 'h5';
        if (platform === 'pc') {
            return <PCTabFilter {...props} filterList={filterList}/>;
        } else {
            return <H5TabFilter {...props} filterList={filterList} />;
        }
        
        
    }
}

export default TabFilter;